import React, { Component } from "react";
import Pillcard from "./Pillcard";
import Classcard from "./Classcard";
import Carousel from "nuka-carousel";
import Grid from '@material-ui/core/Grid';
import './carousel.css';

import { Radio } from 'antd';
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

const printCards = (handler, updateHandler, costHandler, sideEffectHandler, treatsHandler, cards, switchOption, language, cost, costIndex, seIndex, treatsIndex, treatTypes, type) => {
  setTimeout(() => {
    window.dispatchEvent(new Event("resize"));
  }, 0);
  if (switchOption) {
    return cards.map((card, i) => (
      <div className="external">
        <Classcard
          key={i}
          removePillcardHandler={handler}
          classcardobj={card}
          language={language}
        />
      </div>
    ));
  } else {
    return cards.map((card, i) => (
      <div className="external">
        <Pillcard
          key={i}
          removePillcardHandler={handler}
          updatePillcardObjectHandler={updateHandler}
          toggleCostHandler={costHandler}
          toggleSideEffectHandler={sideEffectHandler}
          toggleTreatsHandler={treatsHandler}
          pillcardobj={card}
          language={language}
          cost={cost}
          costIndex={costIndex}
          seIndex={seIndex}
          treatsIndex={treatsIndex}
          treatTypes={treatTypes}
          type={type}
        />
      </div>
    ));
  }
};


export default class MyCarousel extends React.Component  {
  constructor(props) {
    super(props);
    this.state = {
      windowWidth: window.screen.width
    };
    var that = this;
    // Listen for orientation changes
    window.addEventListener(
      // "orientationchange",
      "resize",
      function() {
         // Announce the new orientation number
         return that.resize();
      }
    );
  }

  resize() {
    this.setState({ windowWidth: window.innerWidth });
  }

  position(cards) {
    return cards.length === 1 ? "center" : "left";
  }

  toggleDrawer = (side, open) => () => {
    this.setState({[side]: open});
  };


  render() {
    
    let noOfSlides = 4;
    if (this.state.windowWidth >= 1300) {
      noOfSlides = 3;
    } else {
      noOfSlides = 2;
    }

    let styles_carousel = {};

    if (this.state.windowWidth >= 1000){
      styles_carousel = {
        marginLeft: '150px',
        width: '80%',
      };
    }
    else {
      // styles_carousel = {
      //   marginLeft: '1000px',
      //   width: '80%',
      // }
    }

    const cards = printCards(
      this.props.removePillcardHandler,
      this.props.updatePillcardObjectHandler,
      this.props.toggleCostHandler,
      this.props.toggleSideEffectHandler,
      this.props.toggleTreatsHandler,
      this.props.cards,
      this.props.switchOption,
      this.props.language,
      this.props.cost,
      this.props.costIndex,
      this.props.seIndex,
      this.props.treatsIndex,
      this.props.treatTypes,
      this.props.type
    );
    
    let sideeffectTitlesEng = ["Severe", "Common"];

      return (
        <div>
          <Grid container>
            
            <Grid item style={{marginLeft: "2%", width: 200}}>

              <Grid container direction="column" justify="center" alignItems="flex-start">
                <Grid>
                  <div style={{padding: 140}} />
                </Grid>

                <Grid>
                  <div className="column-left font-comfortaa whatittreats">
                    What it Treats
                    <RadioGroup defaultValue={this.props.treatTypes[this.props.treatsIndex]} onChange={this.props.handleTreat} size="small" style={{marginTop: 5}}>
                      <RadioButton value="fda" className="radio-slider font-comfortaa">FDA</RadioButton>
                      <RadioButton value="offlabel" className="radio-slider font-comfortaa">Off-Label</RadioButton>
                    </RadioGroup>
                  </div>
                </Grid>

                <Grid>
                  <div className="column-left font-comfortaa instructions">
                    Instructions
                  </div>
                </Grid>

                <Grid>
                  <div className="column-left font-comfortaa" style={{minHeight: "calc(12em - 4px)", width: 160, paddingTop: 10, borderBottom: "2.5px solid #efefef"}}>
                    Side Effects
                    <RadioGroup defaultValue={sideeffectTitlesEng[this.props.seIndex]} onChange={this.props.handleSideEffects} size="small" style={{marginTop: 5}}>
                      <RadioButton value="Common" className="radio-slider font-comfortaa">Common</RadioButton>
                      <RadioButton value="Severe" className="radio-slider font-comfortaa">Severe</RadioButton>
                    </RadioGroup>
                  </div>
                </Grid>

                {/* <Grid>
                  <div className="column-left font-comfortaa" style={{minHeight: "calc(7em)", width: 160, paddingTop: 10, borderBottom: "2.5px solid #efefef"}}>
                    Weight{" & "}Sedation
                  </div>
                </Grid> */}

                <Grid>
                  <div className="column-left font-comfortaa" style={{minHeight: "calc(6em - 5px)", width: 160, paddingTop: 10, borderBottom: "2.5px solid #efefef"}}>
                    Time to Effect
                  </div>
                </Grid>
                
                <Grid>
                  <div className="column-left font-comfortaa cost">
                    Cost
                    <div>
                      <RadioGroup defaultValue={this.props.cost[this.props.costIndex]} onChange={this.props.handleCost} size="small" style={{marginTop: 5}}>
                        {<RadioButton value="medicaid" className="radio-slider font-comfortaa">Medicaid</RadioButton>}
                        <RadioButton value="prices" className="radio-slider font-comfortaa">Prices</RadioButton>
                      </RadioGroup>
                    </div>
                  </div>
                </Grid>

                
                <Grid>
                  <div className="column-left font-comfortaa" style={{minHeight: "calc(6em + 2.5px - 14.5px)", width: 160, paddingTop: 10, borderBottom: "2.5px solid #efefef"}}>
                    How it Works
                  </div>
                </Grid>

                
                <Grid>
                  <div className="column-left font-comfortaa" style={{minHeight: "calc(5em + 10px)", width: 160, paddingTop: 10, borderBottom: "2.5px solid #efefef"}}>
                    Additional Monitoring
                  </div>
                </Grid>

                
                <Grid>
                  <div className="column-left font-comfortaa" style={{minHeight: "calc(6em + 3px)", width: 160, paddingTop: 10}}>
                    Custom Notes
                  </div>
                </Grid>

              </Grid>
            </Grid>

            <Grid item xs={9} style={{marginLeft: "-2%"}}>
              <Carousel
                slidesToShow = {noOfSlides}
                withoutControls={true}
                heightMode='max'
                cellAlign={this.position(this.props.cards)}
                swiping={true}
                renderBottomCenterControls={null}
                renderCenterLeftControls={null}
                renderCenterRightControls={null}
                // style={styles_carousel}
                > 
                {cards}
              </Carousel>
            </Grid>

          </Grid>
        </div>
      );
  }
}



// WEBPACK FOOTER //
// ./src/CarouselElements/MyCarousel.js